import React from 'react';
import { StyledBuyerName } from './customer.style';
import type { BuyerNameProps } from '../../types/ConsumerProps';

const Buyer: React.FC<BuyerNameProps> = ({ name, onBuyerClick }) => (
    <StyledBuyerName size="base" weight="bold" data-testid="showroom-header-buyer-name" onClick={onBuyerClick}>
        {name}
    </StyledBuyerName>
);

export default Buyer;
